import _taggedTemplateLiteral from '@babel/runtime/helpers/esm/taggedTemplateLiteral';
import styled from 'styled-components';
import { Collapse, Box } from '@landr/maestro';
import { palette, spacing } from '@landr/maestro-legacy';

var _templateObject, _templateObject2, _templateObject3;
var StyledCollapse = styled(Collapse)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    background-color: transparent;\n    border: none;\n"])));
StyledCollapse.displayName = 'StyledCollapse';
var StyledLeftBorder = styled(Box)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    border-style: solid;\n    border-width: 0 0 0 1px;\n    border-color: ", ";\n    padding-left: ", ";\n"])), palette('neutral.800'), spacing('xs'));
StyledLeftBorder.displayName = 'StyledLeftBorder';
var CollapseIconBox = styled(Box)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    color: ", ";\n    transform: ", ";\n    transition: transform 0.25s ease-out;\n"])), palette('neutral.400'), function (_ref) {
  var isOpened = _ref.isOpened;
  return isOpened ? "rotate(-180deg)" : 'rotate(0)';
});
CollapseIconBox.displayName = 'CollapseIconBox';

export { CollapseIconBox, StyledCollapse, StyledLeftBorder };
